export default "__VITE_ASSET__DZnw4nU8__"